// components/PhotoEditorPreview.js - Component for rendering the preview canvas
import React, { useEffect } from 'react';
import { usePhotoEditorContext } from '../context/PhotoEditorContext';
import { loadCanvases } from '../utils/photoEditor';

const PhotoEditorPreview = ({ show = true }) => {
  const {
    fileURL,
    parentElementRef,
    previewCanvasRef,
    originalSizeCanvasRef
  } = usePhotoEditorContext();

  // Load image into canvases when fileURL changes
  useEffect(() => {
    if (!fileURL) return;
    
    if (!previewCanvasRef.current) {
      console.error('previewCanvasRef.current is null');
      return;
    }
    
    if (!originalSizeCanvasRef.current) {
      console.error('originalSizeCanvasRef.current is null');
      return;
    }
    
    if (!parentElementRef.current) {
      console.error('parentElementRef.current is null');
      return;
    }
    
    loadCanvases(
      previewCanvasRef.current,
      originalSizeCanvasRef.current,
      parentElementRef.current,
      fileURL
    );
  }, [fileURL, previewCanvasRef, originalSizeCanvasRef, parentElementRef]);

  return (
    <>
      <canvas
        ref={previewCanvasRef}
        style={{
          objectFit: 'contain',
          display: show ? 'block' : 'none',
          width: '100%',
          height: 'auto',
          maxHeight: '100%'
        }}
        className="rounded-lg shadow-md"
      />
      <canvas
        ref={originalSizeCanvasRef}
        style={{
          display: 'none' // Hidden canvas for processing
        }}
      />
    </>
  );
};

export default PhotoEditorPreview;
